import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import Navbar from '../Navbar/Navbar'

// You can replace this with your own image path
import aboutImg from '../../assets/heroimg1.png'
import Footer from '../Footer/Footer'

const About = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div>
      <Navbar />
      <Box
        sx={{
          maxWidth: 900,
          mx: 'auto',
          mt: isMobile ? 2 : 5,
          p: isMobile ? 2 : 4,
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center',
          gap: isMobile ? 3 : 6,
        }}
      >
        <Box
          component="img"
          src={aboutImg}
          alt="About us"
          sx={{
            width: isMobile ? '100%' : 350,
            height: isMobile ? 180 : 300,
            objectFit: 'cover',
            borderRadius: 3,
            boxShadow: 3,
          }}
        />
        <Box sx={{ flex: 1 }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, fontSize: isMobile ? '2rem' : '2.5rem' }}>
            About Us
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, fontSize: isMobile ? '1rem' : '1.15rem', color: '#444' }}>
            <b>SUBH BHARAT STUDY TOOL PVT LTD</b> is dedicated to empowering careers and connecting talent with opportunity. Our platform, <b>sabkajobs.com</b>, is designed to bridge the gap between job seekers and recruiters, making the hiring process seamless, transparent, and efficient.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, fontSize: isMobile ? '1rem' : '1.1rem', color: '#444' }}>
            We believe in the power of technology to transform lives. Whether you are searching for your dream job or looking for the perfect candidate, our tools and resources are tailored to help you succeed in today’s competitive job market.
          </Typography>
          <Typography variant="body1" sx={{ fontSize: isMobile ? '1rem' : '1.1rem', color: '#444' }}>
            <b>Why Choose Us?</b>
            <ul style={{ marginTop: 8, marginBottom: 0, paddingLeft: 20 }}>
              <li>Easy-to-use platform for both job seekers and recruiters</li>
              <li>Advanced search and matching algorithms</li>
              <li>Secure and private data handling</li>
              <li>Dedicated support team</li>
              <li>Regular updates and new features</li>
            </ul>
          </Typography>
        </Box>
      </Box>
      <Footer/>
    </div>
  )
}

export default About